<div class="rounded-lg bg-white shadow-cardShadow py-5 px-3 card-size">
    <ng-content></ng-content>
</div>
